$(document).ready(function() {
 if (typeof window.auto_lastValue == 'undefined') {
    window.auto_lastValue = {};
  }
  /* autocomplete 1 */
  $("#id_autocomplete_9655216eedea4a15").bind('keyup',auto_focusOut);
  if ($("#selectGemeente").length > 0) {
    $("#selectGemeente").autocomplete({
      extraParams: {"output":"ajax"},
      originSearch: "searchall",
      autoAddOriginURL: true,
      maxItemsToShow: 15,
      onItemSelect: function (data, autocompleter) { auto_onItemSelect(auto_selectItem, data, autocompleter); },
      beforeUseConverter: auto_beforeUseConverter,
      url: "../gemeente_list"
    });
  }
});

// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
